/**
 * 格式化數字，加上千分位逗號
 * @param {number|string} num - 要格式化的數字
 * @returns {string} 格式化後的數字字串
 */
export const formatNumber = (num) => {
    if (num === null || num === undefined) return '0';
    const number = typeof num === 'string' ? parseFloat(num) : num;
    if (isNaN(number)) return '0';
    return number.toLocaleString('zh-TW');
};

/**
 * 格式化金額
 * @param {number|string} amount - 金額
 * @returns {string} 格式化後的金額字串（含 $ 符號）
 */
export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return '$0';
    const number = typeof amount === 'string' ? parseFloat(amount) : amount;
    if (isNaN(number)) return '$0';
    return `$${number.toLocaleString('zh-TW')}`;
};

/**
 * 格式化百分比
 * @param {number|string} value - 百分比數值（0-100）
 * @param {number} decimals - 小數位數，預設 1
 * @returns {string} 格式化後的百分比字串
 */
export const formatPercentage = (value, decimals = 1) => {
    if (value === null || value === undefined) return '0%';
    const number = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(number)) return '0%';
    return `${number.toFixed(decimals)}%`;
};
